import React from 'react';
import clsx from 'classnames';
import './style.scss';
import { Props } from './types';
import arrowPng from '@/assets/img/arrow-right@2x.png';

export type Ref = HTMLDivElement;

// 去除
// const TransStatus =  {
//   Completed: 'completed',
//   Failed: 'failed',
//   Pending: 'pending'
// } as Record<string, string>;

const TransStatusMap = {
  1: 'Pending',
  2: 'Pending',
  3: 'Completed',
  4: 'Failed',
} as Record<number, string>;

const PREFIX = 'transaction-container';
export default React.forwardRef<Ref, Props>((props, ref) => {
  const { title, amount, image, specification, onClick, layout, status, transReply } = props;

  if (layout === 'vertical') {
    return <VerticalTransaction {...props} ref={ref} />;
  }

  const transStatus = TransStatusMap[status];

  return (
    <div className={PREFIX} onClick={onClick} ref={ref}>
      <div className="transaction-image">
        <img src={image} />
      </div>
      <div className="transaction-info">
        <div className="price" style={{ marginRight: transReply ? '4.375rem' : '' }}>{amount}</div>
        <div className="name">{title}</div>
        <div className="specification">{specification}</div>
        {transStatus && <div className={clsx('status', transStatus)}>{transStatus}</div>}
      </div>
    </div>
  );
});

const VerticalTransaction = React.forwardRef<Ref, Props>(function (props, ref) {
  const { onClick = () => {} } = props;
  const transStatus = TransStatusMap[props.status];
  return (
    <div className="transaction-container-vertical" onClick={onClick} ref={ref}>
      <div className="transaction-image">
        <img src={props.image} />
      </div>
      <div className="transaction-info">
        <div className="name">{props.title}</div>
        <div className="specification">{props.specification}</div>
      </div>
      <div className="price-container">
        <div className="price">{props.amount}</div>
        {transStatus && <div className={clsx('status', transStatus)}>{transStatus}</div>}
      </div>
      <div className="arrow-tail">
        <img src={arrowPng}></img>
      </div>
    </div>
  );
});
